import { useLiveWireStore } from "@/stores/livewire";
import { useCallback, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const useLiveWire = ({ refreshInterval = 60000 }) => {
  const [
    initialized,
    setInit,
    getDailyStats,
    getWeeklyStats,
    getWeeklyAnalystStats,
    getDailyAnalystStats,
    // getPendingCommsStats,
  ] = useLiveWireStore(
    useShallow((state) => [
      state.initialized,
      state.setInit,
      state.getDailyStats,
      state.getWeeklyStats,
      state.getWeeklyAnalystStats,
      state.getDailyAnalystStats,
      // state.getPendingCommsStats,
    ])
  );

  const fetchData = useCallback(async () => {
    console.log("Preloading LiveWire data...");

    return Promise.all([
      getDailyStats(),
      getWeeklyStats(),
      getWeeklyAnalystStats(),
      getDailyAnalystStats(),
      // getPendingCommsStats(),
    ]);
  }, [
    getDailyStats,
    getWeeklyStats,
    getWeeklyAnalystStats,
    getDailyAnalystStats,
    // getPendingCommsStats,
  ]);

  useEffect(() => {
    if (!initialized) {
      fetchData().then(() => {
        setInit(true);
      });
    }
  }, []);

  // Refresh data at specified interval
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchData();
    }, refreshInterval);
    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return {
    fetchData,
    initialized,
    getDailyStats,
    getWeeklyStats,
  };
};
